// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { categoriesStyles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsCategories";
import { css } from "styled-components";

categoriesStyles.container = {
    css: css`
        margin: 15px 0;
    `,
};

categoriesStyles.title = {
    variant: "h2",
    css: css`
        margin-bottom: 16px;
    `,
};

categoriesStyles.categoryImage = {
    width: "149px",
    height: "149px",
    css: css`
        img {
            height: auto;
            object-fit: contain;
        }
    `,
};

categoriesStyles.categoryNameLink = {
    typographyProps: {
        weight: "bold",
        css: css`
            width: 100%;
            overflow-wrap: break-word;
            word-wrap: break-word;
            text-align: center;
        `,
    },
    color: "text.main",
    css: css`
        width: 100%;
    `,
};

categoriesStyles.subCategoryLink = {
    typographyProps: {
        css: css`
            width: 100%;
            overflow-wrap: break-word;
            word-wrap: break-word;
            text-align: center;
        `,
    },
    css: css`
        width: 100%;
    `,
};

categoriesStyles.viewMoreLink = {
    typographyProps: {
        css: css`
            width: 100%;
            text-align: center;
        `,
    },
    css: css`
        width: 100%;
    `,
};

categoriesStyles.innerCategoryContainer = {
    gap: 10,
    css: css`
        width: 100%;
    `,
};
